// generiskConfig.js
const geneRiskConfig = {
  api: {
    baseUrl: 'https://servicewsgenerisk.szapfs.org',
    endpoints: {
  webserverCookie: '/webserver_cookie',
  uploadChunkSimple: '/upload-chunk-simple',
  finalizeUploadSimple: '/finalize-upload-simple',
  jobs: '/jobs'                  // ← add this
    }
  }
};

export function getApiBaseUrl() {
  return geneRiskConfig.api.baseUrl;
}

/** Get full URL for a known endpoint key */
export function getApiEndpoint(key) {
  const baseUrl = geneRiskConfig.api.baseUrl;
  const path = geneRiskConfig.api.endpoints[key];
  return `${baseUrl}${path}`;
}

/** Build URL with path params or query if needed later */
export function buildApiUrl(path) {
  return `${geneRiskConfig.api.baseUrl}${path}`;
}

/** Standard headers including the cookie */
export function authHeaders(cookieId, extra = {}) {
  return {
    'x-cookie-id': cookieId || '',
    ...extra,
  };
}

export default geneRiskConfig;
